<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="category">
                <wbo-category-exclude-sub-search-control></wbo-category-exclude-sub-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'includesProductId'">
                <wbo-product-line-multi-select-search-control></wbo-product-line-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'includesExtraId'">
                <wbo-extra-multi-select-search-control></wbo-extra-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-column field="description" [maxWidth]="100"></wbo-column>
        <wbo-column field="categoryName"></wbo-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
